import { render, staticRenderFns } from "./DashAsideLeft.vue?vue&type=template&id=6e0bed3c&scoped=true&"
import script from "./DashAsideLeft.vue?vue&type=script&lang=ts&"
export * from "./DashAsideLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0bed3c",
  null
  
)

export default component.exports